import React, { useContext, useEffect, useState } from 'react';
import { Button, Grid, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import NoData from '../../../../../../components/Common/NoData';
import PollsTableBody from './Components/PollTableBody';
import { LanguageContext } from '../../../../../../libs/Context';
import CreatePoll from './Components/CreatePoll';
import { Add } from '@mui/icons-material';
import { getPolling } from '../../../../../actions/meeting_actions';
import Loading from '../../../../../../components/Common/Loaders/FullWidthLoader/Loading';
import { catchErr, generateRandomUUID } from '../../../../../../libs/HelperContent';

const PollsTable = (props) =>
{
	const { form, handleBackCallBack, handleSkipFinish,
		handleNextCallBack, handleDeletePop } = props;
	const { language } = useContext(LanguageContext);
	const [ status, setStatus ] = useState<string>('');
	const [ editPoll, setEditPoll ] = useState<any>({});
	const [ pollsList, setPollsList ] = useState<any>([]);
	const [ loading, setLoading ] = useState(false);

	const handlePollCreate = (data, type) =>
	{
		if (type === 'edit')
		{
			const filterData = pollsList?.map((each) =>
			{
				if (each?._id === data?._id)
				{
					return data;
				}
				else
				{
					return each;
				}
			});

			setPollsList(filterData);
		}
		else
		{
			setPollsList([ ...data, ...pollsList ]);
		}
		setStatus('');
	};

	const handleUpdatePoll = (e, pollData) =>
	{
		setStatus('edit');
		setEditPoll(pollData);
	};

	const handleClose = () =>
	{
		setStatus('');
		setEditPoll({});
	};

	const handleDelete = (each) =>
	{
		const filterData = pollsList?.filter((item) => item?._id !== each?._id);

		setPollsList(filterData);
	};

	const getPollData = async () =>
	{
		setLoading(true);
		const query = {
			sessionId : form?.id
		};

		try
		{
			const res = await getPolling(query);

			if (res?.status)
			{
				setPollsList(res?.data);
			}
			else
			{
				setPollsList([]);
			}
		}
		catch (err)
		{
			// eslint-disable-next-line no-console
			console.log(err, '=================>');
			catchErr(err);
		}
		setLoading(false);
	};

	useEffect(() =>
	{
		getPollData();
	}, []);

	const isListData = pollsList?.length > 0;

	const handleBack = () =>
	{
		handleBackCallBack();
	};

	const handleNext = () =>
	{
		handleNextCallBack();
	};

	const isEditOrCreate = [ 'create', 'edit' ].includes(status);

	return (
		<>
			<Stack direction='column' height='calc(100% - 56px)'>
				{loading && <Loading/>}
				<Grid container px='var(--pixel16)' py='6px' alignItems={isListData ? '' : 'center'} height={isListData ? '' : 'var(--percent100)'} justifyContent={isListData ? '' : 'center'}>
					<Grid item xs={12}>
						{isEditOrCreate &&
							(
								<CreatePoll
									handleClose={handleClose}
									handlePollCreate={handlePollCreate}
									status={status}
									editPoll={editPoll}
								/>
							)}
						{!isEditOrCreate && !isListData &&
							<Stack direction='column' alignItems='center' height='var(--percent100)' justifyContent='center'>
								<NoData noDataHead={language?.nopollsCreated}
									src1={'/images/icons/webPolling.svg'}
									heightimg={'var(--font100)'}
									color='pdngTSM fontWeightSM'
								/>
								<Button color='primary' variant='outlined' disableElevation onClick={() => setStatus('create')}>{language?.createPoll}</Button>
							</Stack>}
						{!isEditOrCreate && isListData && <>
							<Grid item display={'flex'} justifyContent={'end'} pb='var(--pixel8)'>
								<Button startIcon={<Add/>} color='primary' variant='outlined' disableElevation onClick={() => setStatus('create')}>{language?.addPolls}</Button>
							</Grid>
							<TableContainer sx={{ maxHeight: '70vh', overflow: 'auto', border: '1px solid rgba(0,0,0,0.12)', borderRadius: 'var(--pixel8)' }}>
								<Table stickyHeader aria-label='sticky table'>
									<TableHead>
										<TableRow>
											<TableCell sx={{ fontWeight: 'bold' }}>{language.pollQuestions}</TableCell>
											<TableCell sx={{ fontWeight: 'bold' }} colSpan={3}>{language.type}</TableCell>
										</TableRow>
									</TableHead>
									<TableBody>
										{pollsList?.map((item, index) => (
											<PollsTableBody
												key={item?._id ?? item?.id ?? generateRandomUUID()}
												eachItem={item}
												handleUpdate={handleUpdatePoll}
												handleDelete={handleDelete}
											/>
										))}
									</TableBody>
								</Table>
							</TableContainer>
						</>
						}
					</Grid>
				</Grid>
			</Stack>
			{!isEditOrCreate &&
			<Grid
				container
				justifyContent={'space-between'}
				alignItems='center'
				p='var(--pixel16)'
			>
				<Stack
					direction='row'
					alignItems='center'
					spacing={1}
				>
					<Button
						variant='outlined'
						onClick={handleBack}
					>
						{language?.previous}
					</Button>
					<Button onClick={handleSkipFinish} variant='outlined'>
						{language?.skipandFinish}
					</Button>
				</Stack>
				<Grid item>
					<Stack direction='row' spacing={1}>
						<Button
							onClick={handleDeletePop}
							variant='outlined'
						>
							{language?.cancel}
						</Button>
						<Button
							variant='contained'
							sx={{ color: 'var(--whiteColor)' }}
							onClick={handleNext}
						>
							{language?.next}
						</Button>
					</Stack>
				</Grid>
			</Grid>}
		</>
	);
};

export default PollsTable;
